import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class DetalhamentoSimulacaoService {

  constructor(
    private http: HttpService
  ) { }

  cancelaSimulacao(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/enterprise/cancelaSimulacaoVendaPinPos/' + data, successHandle, errorHandle);

  }

  searchPinSumulator(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/enterprise/searchPinSumulator?sort=dataLancamento%2Cdesc', data, successHandle, errorHandle);

  }

}
